import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { VisuallyHidden } from 'radix-ui'
import { SizeGuide } from '@/api'

type SizeGuideModalProps = {
  open: boolean
  setOpen: (open: boolean) => void
  sizeGuide: SizeGuide[]
}

const SIZE_GUIDE_FIELDS = [
  { key: 'chestWidth', label: '身幅 (cm)' },
  { key: 'shoulderWidth', label: '肩幅 (cm)' },
  { key: 'length', label: '着丈 (cm)' },
  { key: 'sleeveLength', label: 'そで丈 (cm)' },
  { key: 'height', label: '身長 (cm)' },
  { key: 'headCircumference', label: '頭囲 (cm)' },
] as const

export const SizeGuideModal = ({
  open,
  setOpen,
  sizeGuide,
}: SizeGuideModalProps) => {
  const availableFields = SIZE_GUIDE_FIELDS.filter((field) =>
    sizeGuide.some((item) => item[field.key] != null)
  )

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="bg-white rounded-none max-w-[85%] lg:w-[70%] lg:max-w-[700px] px-2.5 lg:px-[100px] pb-9 py-9 lg:py-[56px]">
        <VisuallyHidden.Root>
          <DialogHeader>
            <DialogTitle>サイズガイド</DialogTitle>
          </DialogHeader>
        </VisuallyHidden.Root>
        <div>
          <div className="flex items-center bg-[#F6F6F6]">
            <div className="flex-1 text-sm lg:text-base font-bold text-center px-2 py-2 lg:px-3.5 lg:py-3 flex justify-center items-center border-r border-solid border-[#E8E8E8]">
              サイズ
            </div>
            {availableFields.map((field) => (
              <div
                key={field.key}
                className="flex-1 text-sm lg:text-base font-bold text-center px-2 py-2 lg:px-3.5 lg:py-3 flex justify-center items-center border-r border-solid border-[#E8E8E8] last:border-none"
              >
                {field.label}
              </div>
            ))}
          </div>

          {sizeGuide.map((item) => (
            <div
              key={item.id}
              className="flex justify-between items-center odd:bg-[#F6F6F6]"
            >
              <div className="flex-1 text-xs lg:text-base font-bold text-center px-2 py-3 lg:px-3.5 border-r border-solid border-[#E8E8E8]">
                {item.size?.name || ''}
              </div>
              {availableFields.map((field) => (
                <div
                  key={field.key}
                  className="flex-1 text-xs lg:text-base font-bold text-center px-2 py-3 lg:px-3.5 border-r border-solid border-[#E8E8E8] last:border-none"
                >
                  {item[field.key] || '-'}
                </div>
              ))}
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
